// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"4860b559","994":"f59224f3"}[chunkId] + ".chunk.css";
};